// Environment variables, with some defaults
export const IS_DEVELOPMENT = import.meta.env.DEV;
export const API_URL = import.meta.env.VITE_API_URL || "http://localhost:3001";
export const AUTH_CLIENT_ID = import.meta.env.VITE_AUTH_CLIENT_ID || "mydsa-ui";
export const AUTH_REALM = import.meta.env.VITE_AUTH_REALM || "dsa";
export const AUTH_URL = import.meta.env.VITE_AUTH_URL || "http://localhost:8080";
export const CONTACT_EMAIL =
  import.meta.env.VITE_CONTACT_EMAIL || "techteam@dsausa.org";
export const DSA_FAQ_URL = "https://www.dsausa.org/resources/faq/";
export const EMAIL_UPDATES_ENABLED =
  import.meta.env.VITE_EMAIL_UPDATES_ENABLED === "true";

export const States = [
  "AK",
  "AL",
  "AR",
  "AS",
  "AZ",
  "CA",
  "CO",
  "CT",
  "DC",
  "DE",
  "FL",
  "GA",
  "GU",
  "HI",
  "IA",
  "ID",
  "IL",
  "IN",
  "KS",
  "KY",
  "LA",
  "MA",
  "MD",
  "ME",
  "MI",
  "MN",
  "MO",
  "MS",
  "MT",
  "NC",
  "ND",
  "NE",
  "NH",
  "NJ",
  "NM",
  "NV",
  "NY",
  "OH",
  "OK",
  "OR",
  "PA",
  "PR",
  "RI",
  "SC",
  "SD",
  "TN",
  "TX",
  "UT",
  "VA",
  "VI",
  "VT",
  "WA",
  "WI",
  "WV",
  "WY",
  "MP",
  "UM",
  "AA",
  "AP",
  "AE",
];
